import React, {Fragment, useState, useEffect} from 'react'
import axios from 'axios';
import { FaRegCalendar, FaRegClock } from "react-icons/fa";
import globals from 'react-global-configuration';
import Moment from 'react-moment'
import {Link} from "react-router-dom";


import {Card, ContentLink, Title, Separador, Desc, Cont,Linkover, Info, TxtDate} from './styles'


const EventCard = ({cover,  idevent ,  fecha, title, res}) => {
    const [imgurl, setimgurl] = useState('./images/ico_descarga.svg');
    
    const _URL_REST = globals.get('_URL_REST');
    

    const [data, setData] = useState(null);
    const [settings, setSettings] = useState(null);
    

    useEffect(() => {
        async function fetchData() {
          // You can await here
          const result = await axios(
            `${_URL_REST}/getinfoevento/${idevent}`,
        );
        //console.log('DATOS:: result.data',result.data[0])
        setData(result.data[0]);
          // ...
        }
        //console.log('CALL....')
        fetchData();
    }, [_URL_REST]);


    const fetchSettings = async () => {
        const result = await axios(
            `${_URL_REST}/getsettings/${idevent}`,
        );
        setSettings(result.data[0])
    };
  
    useEffect(() => {
        fetchSettings();
    },[]);

    if (!data) {
        //console.log('IS NULL')
        return <div></div>  
    }

    const saveLog = async (idevento) => {
        let bajodemanda = false
        settings.streaming ? bajodemanda = false : bajodemanda = true
        var dataFormlog = {  
            "idUsuario": sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_USERRADIO`),
            "idEvento": idevento,
            "ip": "192.168.1.1",
            "BajoDemanda": bajodemanda,
            "Navegador": `${window.navigator.userAgent}`
        }

        const urllog = `https://eventosonline.spinmedia.es/api/eventos/GrabarEventoLog`
        const requestOptionslog = {
          method: 'POST',
          body: JSON.stringify(dataFormlog),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization':`Bearer ${sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-Nombre_TOKENUSERRADIO`)}`
          },  
        }
        let respuestalog = await fetch(urllog, requestOptionslog)
        let resultadolog = await respuestalog.json()

    }
    
    if(data.visible == 0 ){ return('') } 
    if(!settings){ return('') } 
    return (
        
            <Cont id={idevent}>
                <ContentLink>
                    <Link onClick={() => saveLog(idevent)} title={title}  rel='noopener noreferrer' to={`/evento/${idevent}`}>
                        <img
                            src={`${process.env.PUBLIC_URL}/eventos/imagen/${idevent}.png`}
                            alt=""
                        />
                        <Info>
                            <Title>
                                {title}
                            </Title>
                            <Desc>
                           
                            {
                                settings.mostrarTXTOnDemand === 1 ?
                            
                                    <div><span>On Demand</span></div>
                            :
                                <Fragment>
                                    <div>
                                        <span><FaRegCalendar />  <Moment format="DD/MM/YYYY">{fecha}</Moment> </span>
                                        <TxtDate></TxtDate>
                                    </div>
                                    <div>
                                        <span><FaRegClock/> {data.hora} </span>
                                        <TxtDate></TxtDate>
                                    </div>
                                </Fragment>
                                }
                               
                            </Desc>
                        </Info>
                    </Link>
                </ContentLink>
            </Cont>

    )
}

export default EventCard